import BreadcrumbComp from "@components/UI/Breadcrumb/Index";
import Associacao from "./Associacao";
import ModalCompliance from "./Modal";
import { useState } from "react";

function ComplianceSectionCreateSolicitacao({
    methods,
    complianceData,
    setComplianceData
}) {
    const NomeForm = "Associação da Solicitação a um Compliance";
    const [visible, setVisible] = useState(false);
    const openModal = () => setVisible(true);
    const closeModal = () => setVisible(false);

    return (
        <div className="row">
            <BreadcrumbComp Param1="Home" Param2="Solicitações e Pendências" Param3={"Cadastro de Solicitação"} />
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-md-6 d-flex align-items-center">
                                <h2 className="mb-0">{NomeForm}</h2>
                            </div>

                            <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                                <button className="btn btn-menu" type='button'>
                                    <i className="fa-solid fa-bars"></i>
                                </button>
                            </div>
                            
                            <Associacao
                                compliance={complianceData}
                                setCompliance={setComplianceData}
                                openModal={openModal}
                            />

                            <ModalCompliance
                                visible={visible}
                                closeModal={closeModal}
                                compliance={complianceData}
                                setCompliance={setComplianceData}
                                setValue={methods.setValue}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ComplianceSectionCreateSolicitacao;